import styled from 'styled-components';
import { Form as BaseForm, Field as BaseField } from 'formik';

import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';
import { CustomTitle } from 'shared/components/presentational/Title/sharedTitles';
import BaseWrapper from 'shared/components/presentational/Wrapper/Wrapper';

export const Wrapper = styled(BaseWrapper)`
  padding: 0 var(--container-minimum-padding);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  --title-position: left;
`;

export const HeadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

export const Subtitle = styled.p`
  font-size: var(--text-size-base);
  line-height: var(--line-height-m);
  font-weight: ${FONT_WEIGHTS.normal};
  color: var(--text-title);
  margin: 0;
`;

export const RenewalNumber = styled.span`
  font-weight: ${FONT_WEIGHTS.demi};
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-m);
  padding: var(--spacing-s);
  border: 1px solid var(--surface-border-default);
`;

export const DetainedOffer = styled.p`
  font-size: var(--text-size-base);
  margin: 0;
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-m);
`;

export const CardContentWrapperLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xxs);
`;

export const OfferTitle = styled(CustomTitle)`
  font-size: var(--text-size-base);
  line-height: var(--line-height-m);
`;

export const EndingDate = styled.p`
  margin: 0;
  color: var(--text-light);
`;

export const AlertBoxContainer = styled.div`
  margin: var(--spacing-l) var(--spacing-m);
`;

export const Form = styled(BaseForm)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-m);
`;

export const OptionsTitle = styled(CustomTitle)`
  font-family: ${FONT_FAMILIES.base};
  font-weight: ${FONT_WEIGHTS.demi};
`;

export const Field = styled(BaseField)<{ disabled: boolean }>`
  text-decoration: ${props => (props.disabled ? 'line-through' : 'none')};
`;

export const OptionsList = styled.ul`
  border: 1px solid var(--surface-border-default);
`;

export const Option = styled.li`
  padding: var(--spacing-m);

  &:not(:last-child) {
    border-bottom: 1px solid var(--surface-border-default);
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;
